export const SITE_SETTING = 'Site Setting';
export const GLOBAL_CONTENT = 'Global content';
